export const GET_CUSTOMER_LIST = 'GET_CUSTOMER_LIST'

export const getCustomer = () => {
    return {
        type: GET_CUSTOMER_LIST
    }
}